import { DefaultTheme } from 'styled-components';

const DefaultAppTheme: DefaultTheme = {
  name: 'Default'
}

export default DefaultAppTheme; 